import { render, staticRenderFns } from "./UploadImageCloudinary.vue?vue&type=template&id=2297ebfa"
import script from "./UploadImageCloudinary.vue?vue&type=script&lang=js"
export * from "./UploadImageCloudinary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports